module.exports = __webpack_public_path__ + "img/disable-site.ba2ef54.svg";